import React, { useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import Drawer from "@material-ui/core/Drawer";

const INFO = [
  {
    id: 1,
    badge: "예약 1",
    text: "예약한 순번,",
    subText: "좌석지정제인 경우 예약한 좌석번호",
    className: "blue",
  },
  {
    id: 2,
    badge: "좌석 미지정",
    text: "수업의 좌석 예약 설정을 변경하여",
    subText: "좌석 지정 없이 예약된 경우",
    className: "blue",
  },
  {
    id: 3,
    badge: "출석 -1",
    text: "출석 차감 횟수",
    className: "green",
  },
  {
    id: 4,
    badge: "결석 -1",
    text: "결석 차감 횟수",
    className: "red",
  },
  {
    id: 5,
    badge: "대기 1",
    text: "대기한 순번",
    className: "gray",
  },
];

function InfoPop() {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SCHDULE_DTL_INFO_POP",
      open: { scheduleDtlInfoPop: false },
    });
  };

  return (
    <React.Fragment>
      <Drawer
        anchor="bottom"
        open={state.scheduleDtlInfoPop}
        onClose={handleClose}
        className="picker-pop auto"
      >
        <PickerHeader title="예약 출석 현황 안내드려요!" onClose={handleClose} />
        <div className="picker-body">
          <div className="schedule-dtl-info-pop">
            {INFO.map((info) => (
              <div className={`info ${info.id > 2 ? "aligned" : ""}`} key={info.id}>
                <div className={`badge ${info.className}`}>{info.badge}</div>
                {info.id <= 2 ? (
                  <div className="text">
                    {info.text} <br /> {info.subText}
                  </div>
                ) : (
                  <div className="text">{info.text}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
}

export default InfoPop;
